'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _components2 = require('components');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

require('./App.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    AppView: {
        displayName: 'AppView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/containers/App/default/AppView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var AppView = _wrapComponent('AppView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(AppView, _Component);

    function AppView() {
        (0, _classCallCheck3.default)(this, AppView);
        return (0, _possibleConstructorReturn3.default)(this, (AppView.__proto__ || (0, _getPrototypeOf2.default)(AppView)).apply(this, arguments));
    }

    (0, _createClass3.default)(AppView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                drop = _props.drop,
                viewSearchAndMenu = _props.viewSearchAndMenu,
                user = _props.user,
                viewFooter = _props.viewFooter;

            var result = null;

            if (viewSearchAndMenu) {
                // if (true) {
                result = _react3.default.createElement(
                    'div',
                    { className: 'row' },
                    _react3.default.createElement(_components2.Menu, { drop: drop }),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-8 col-md-9' },
                        _react3.default.createElement(_components2.Search, null),
                        !drop ? this.props.children : ''
                    )
                );
            }

            return _react3.default.createElement(
                'div',
                { className: 'App__view u-full-height' },
                _react3.default.createElement(_reactHelmet2.default, _config2.default.app.head),
                _react3.default.createElement(_components2.Header, { user: user }),
                _react3.default.createElement(
                    'div',
                    { className: 'flex_wrapper' },
                    _react3.default.createElement(
                        'div',
                        { className: 'flex_content ' + (viewFooter ? '' : 'u-full-height') },
                        _react3.default.createElement(
                            'div',
                            { className: 'App__content u-full-height' },
                            _react3.default.createElement(
                                'div',
                                { className: 'container u-full-height' },
                                _react3.default.createElement(_components2.AlertError, null),
                                result,
                                drop ? this.props.children : ''
                            )
                        )
                    ),
                    viewFooter ? _react3.default.createElement(_components2.Footer, null) : null
                ),
                _react3.default.createElement(_components2.ModalWindow, null)
            );
        }
    }]);
    return AppView;
}(_react2.Component), _class.propTypes = {
    children: _react2.PropTypes.object.isRequired,
    drop: _react2.PropTypes.bool,
    viewSearchAndMenu: _react2.PropTypes.bool.isRequired,
    viewFooter: _react2.PropTypes.bool.isRequired,
    user: _react2.PropTypes.object
}, _temp));

exports.default = AppView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/default/AppView.jsx
// module id = 1798
// module chunks = 0